import { replace } from 'connected-react-router';

import {
    initiateDonation,
    completeDonation,
    getPaymentNonceFromCreditCard
} from '../../utils/donation/donationApi';

import { requestVenmoInstance, deviceData } from '../../utils/donation/braintree';

import {
    ACTION_COMPLETED_LOCAL_REP,
    EMAIL_COLLECTED,
    IS_NEXT_ACTION_TRANSITION,
    SET_END_USER_ID,
    SHOW_NEXT_ACTION_ANIMATION,
    onFinishMultiAction
} from '../Widget/actions';

import { NativePaymentsTypes, PaymentMethod } from '../../utils/enums';
import config from '../../config';
import { isPortrait } from '../../utils/size';

export const AWAITING_BRAINTREE_RESPONSE = 'AWAITING_BRAINTREE_RESPONSE';
export const CUSTOM_AMOUNT_CHANGED = 'CUSTOM_AMOUNT_CHANGED';
export const CLEAR_DONATION_PAYMENT_PROVIDER = 'CLEAR_DONATION_PAYMENT_PROVIDER';
export const DONATE_MORE = 'DONATE_MORE';
export const DONATION_DONE = 'DONATION_DONE';
export const DONATION_GO_BACK_TO_AMOUNT = 'DONATION_GO_BACK_TO_AMOUNT';
export const DONATION_PAYMENT_PROVIDER_SELECTED = 'DONATION_PAYMENT_PROVIDER_SELECTED';
export const DONATION_SUBMITTING = 'DONATION_SUBMITTING';
export const DONATION_SUBMITTING_ERROR = 'DONATION_SUBMITTING_ERROR';
export const DONATION_SUCCESS = 'DONATION_SUCCESS';
export const MOBILE_GO_WIZARD_STEP = 'MOBILE_GO_WIZARD_STEP';
export const REVEAL_CREDIT_CARD_FORM = 'REVEAL_CREDIT_CARD_FORM';
export const SELECT_AMOUNT = 'SELECT_AMOUNT';
export const SET_DEVICE_DATA = 'SET_DEVICE_DATA';
export const SET_NATIVE_PAYMENT_AVAILABILITY = 'SET_NATIVE_PAYMENT_AVAILABILITY';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const DONATION_ORGHUNTER_VALIDITY_CHANGE = 'DONATION_ORGHUNTER_VALIDITY_CHANGE';

let toasterTimeout = null;
let anim = null;
let framePause = 93;

const jsonAnimation = isMobileResolution => {
    const baseURL = config.DEFAULT_IMAGES_URL;
    const type = isMobileResolution
        ? `DonationSubmittingAnimation_Mobile.json`
        : `DonationSubmittingAnimation_Desktop.json`;
    return baseURL + type;
};

let animationData;

export const loadAnim = async container => {
    let lottie;
    await import('lottie-web').then(l => (lottie = l.default));
    anim = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData
    });
    const startFrame = 20;
    anim.playSegments([startFrame, framePause], true);
};

export const selectAmount = (apiRequestData, request) => dispatch => {
    const jsonRequest = new Request(jsonAnimation(isPortrait()));
    fetch(jsonRequest)
        .then(response => response.json())
        .then(data => (animationData = data));

    dispatch({
        type: SELECT_AMOUNT,
        payload: Number.isInteger(request.amount)
            ? request.amount
            : parseInt(request.amount, 10)
    });

    dispatch({
        type: AWAITING_BRAINTREE_RESPONSE,
        payload: true
    });

    dispatch({
        type: DONATE_MORE,
        payload: false
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    initiateDonation(apiRequestData, request)
        .then(data => {
            dispatch({
                type: SET_PAYMENT_INFO,
                payload: { ...data, ...request }
            });
        })
        .then(() => {
            setTimeout(() => {
                dispatch({
                    type: AWAITING_BRAINTREE_RESPONSE,
                    payload: false
                });
            }, 1000);
            dispatch(replace('/donation/details'));
        });
};

export const donateMore = isEnabled => dispatch => {
    dispatch({
        type: DONATE_MORE,
        payload: isEnabled
    });
};

export const onCustomAmountChanged = (event, values) => dispatch => {
    dispatch({
        type: CUSTOM_AMOUNT_CHANGED,
        payload: values.value
    });
};

export const onBackToAmount = () => dispatch => {
    dispatch({
        type: DONATION_GO_BACK_TO_AMOUNT
    });
    dispatch(replace('/donation'));

    setTimeout(() => {
        dispatch({ type: CLEAR_DONATION_PAYMENT_PROVIDER });
    }, 500);
};

export const onOrgHunterCcValidityChange = (fieldName, isValid) => dispatch => {
    dispatch({
        type: DONATION_ORGHUNTER_VALIDITY_CHANGE,
        payload: { fieldName: fieldName, isValid: isValid }
    });
};

export const mobileGoWizardStep = step => dispatch => {
    dispatch({
        type: MOBILE_GO_WIZARD_STEP,
        payload: step
    });
};

function getTimeFrom(fromDate) {
    return (new Date() - fromDate) / 1000;
}

export const setupApplePay = () => dispatch => {
    if (!!window.ApplePaySession) {
        dispatch({
            type: SET_NATIVE_PAYMENT_AVAILABILITY,
            payload: NativePaymentsTypes.applePay
        });
    }
};

export const setupGooglePay = () => dispatch => {
    if (window.google && window.google.payments && !!window.ApplePaySession === false) {
        dispatch({
            type: SET_NATIVE_PAYMENT_AVAILABILITY,
            payload: NativePaymentsTypes.googlePay
        });
    }
};

export const setBraintreeDeviceInfo = payment => dispatch => {
    deviceData(payment).then(data => {
        dispatch({
            type: SET_DEVICE_DATA,
            payload: data
        });
    });
};

export const setupVenmo = payment => dispatch => {
    if (payment.paymentMethod === PaymentMethod.Braintree) {
        requestVenmoInstance(payment).then(venmoInstance => {
            if (venmoInstance.isBrowserSupported()) {
                dispatch({
                    type: SET_NATIVE_PAYMENT_AVAILABILITY,
                    payload: NativePaymentsTypes.venmo
                });
            }
        });
    }
};

export const toggleCreditCardForm = bool => dispatch => {
    dispatch({
        type: REVEAL_CREDIT_CARD_FORM,
        payload: !bool
    });
};

export const selectPaymentProvider = (
    paymentProviderId,
    oldSelectedProvider
) => dispatch => {
    if (paymentProviderId !== oldSelectedProvider) {
        dispatch({
            type: DONATION_PAYMENT_PROVIDER_SELECTED,
            payload: paymentProviderId
        });
    }

    if (paymentProviderId === NativePaymentsTypes.credtCard) {
        dispatch({
            type: REVEAL_CREDIT_CARD_FORM,
            payload: true
        });
    }
};

export const submitDonationCompleted = (
    apiRequestData,
    data,
    isMultiActionsCard,
    actionIdentifier,
    selectedAmountTime,
    feedbackText,
    partnerName,
    skipEndCard,
    paymentProvider,
    providerSpecificInfo,
    deviceData
) => dispatch => {
    dispatch({
        type: DONATION_SUBMITTING,
        payload: true
    });
    let actionCompleteTime = getTimeFrom(selectedAmountTime);
    completeDonation(
        apiRequestData,
        { ...data, actionCompleteTime },
        paymentProvider,
        deviceData
    )
        .then(response => {
            if (anim && !isMultiActionsCard) {
                anim.playSegments([framePause, 144], true);
            }
            setTimeout(() => {
                dispatch({
                    type: SET_END_USER_ID,
                    payload: response.endUserId
                });

                dispatch({
                    type: DONATION_SUCCESS,
                    payload: { ...response, actionIdentifier }
                });

                dispatch({
                    type: SET_SUCCESS_INFO,
                    payload: {
                        feedbackText,
                        partnerName,
                        paymentProvider,
                        providerSpecificInfo
                    }
                });

                dispatch({
                    type: ACTION_COMPLETED_LOCAL_REP
                });

                if (data.getUpdates) {
                    dispatch({
                        type: EMAIL_COLLECTED,
                        payload: true
                    });
                }

                if (isMultiActionsCard) {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                } else if (!skipEndCard) {
                    dispatch(replace('/donation/success'));
                }
                setTimeout(() => {
                    dispatch({
                        type: DONATION_SUBMITTING,
                        payload: false
                    });
                    dispatch({
                        // resetting form to begining in case there's another donation
                        type: MOBILE_GO_WIZARD_STEP,
                        payload: 1
                    });
                }, 700);
            }, 1500);
        })
        .catch(errorMessage => {
            dispatch({
                type: DONATION_SUBMITTING_ERROR,
                payload: errorMessage
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: DONATION_SUBMITTING_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: DONATION_SUBMITTING,
                payload: false
            });
        });
};

export const submitDonationCreditCard = (
    nonce,
    apiRequestData,
    paymentInfo,
    values,
    paymentMethod,
    selectedAmountTime,
    isMultiActionsCard,
    actionIdentifier,
    feedbackText,
    partnerName,
    skipEndCard
) => dispatch => {
    dispatch({
        type: DONATION_SUBMITTING,
        payload: true
    });
    getPaymentNonceFromCreditCard(paymentMethod, {
        ...paymentInfo,
        ...values,
        nonce
    }).then(data =>
        submitDonationCompleted(
            apiRequestData,
            { ...values, ...paymentInfo, ...data },
            isMultiActionsCard,
            actionIdentifier,
            selectedAmountTime,
            feedbackText,
            partnerName,
            skipEndCard,
            NativePaymentsTypes.credtCard
        )(dispatch)
    );
};
